export default {
  header: 'Lehrlingsbereich',
  counter_title: 'Studenten',
  become_students_coordinator: 'Lehrlingsausbilder:in werden',
  delete_from_students_btn: 'Aus Organisation entfernen',
  move_to_organizatio_btn: 'Verschieben in Nutzer:innen-Bereich',

  no_members:
    'Es befinden sich noch keine Mitglieder in Ihrem Lehrlingsbereich. Starten Sie damit, Lehrlingskoordinator:innen und Lehrlinge einzuladen.',
}
